'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

require('intersection-observer');

var _rimgShopify = require('rimg-shopify');

var _rimgShopify2 = _interopRequireDefault(_rimgShopify);

var _loadjs = require('loadjs');

var _loadjs2 = _interopRequireDefault(_loadjs);

var _Addresses = require('../pages/customers/Addresses');

var _Addresses2 = _interopRequireDefault(_Addresses);

var _Login = require('../pages/customers/Login');

var _Login2 = _interopRequireDefault(_Login);

require('../../styles/templates/customer.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scriptsEl = document.querySelector('[data-scripts]');
var scripts = JSON.parse(scriptsEl.innerHTML);

var Customers = function Customers() {
  var _this = this;

  (0, _classCallCheck3.default)(this, Customers);

  this.el = document.body;

  if (this.el.classList.contains('template-customers-login')) {
    this.templateAccountLogin = new _Login2.default({ el: this.el });
  }

  if (this.el.classList.contains('template-customers-addresses')) {
    (0, _loadjs2.default)(scripts.customer_area, function () {
      _this.templateAccountAddresses = new _Addresses2.default({ el: _this.el });
    });
  }

  _rimgShopify2.default.init();
};

exports.default = Customers;


(0, _loadjs2.default)([scripts.customer_area, scripts.shopify_common], function () {
  new Customers();
});